import * as React from 'react';
// @ts-ignore
import ReactModal from 'react-modal';
import {ChangeEvent} from "react";
// We can just import Slider or Range to reduce bundle size
export interface IInput {
    value: string|number,
    label: string,
    onChange: (...args:any[]) => void;
}

export interface IProps {
    onClose: any;
    cancel?: any;
    showCancel?: boolean;
    show: boolean;
    completeButtonLabel?: string;
    inputs?: IInput[];
    title: string;
    content: React.ReactNode;
    invalid?: boolean;
}

export interface IState {
    value: number | null;
    values: any;
}

export class BasicModal extends React.PureComponent<IProps, IState> {
    // ref: any = React.createRef();
    constructor(props: IProps) {
        super(props);
        this.state = {
            value: null,
            values: {}
        };
    }

    componentDidMount(): void {
        document.body.addEventListener('click', this.handleOutsideClick);
    }

    componentWillUnmount(): void {
        document.body.removeEventListener('click', this.handleOutsideClick);
    }

    handleOutsideClick = (e: MouseEvent): void => {
        if (!this.props.show) return;
        if ((e.target as HTMLDivElement).className === 'overlays') {
            this.props.cancel();
        }
        if ((e.target as HTMLDivElement).className === 'ReactModal__Overlay ReactModal__Overlay--after-open') {
            this.props.cancel();
        }
    }

    handleClose = () => {
        if (this.props.invalid) {
            return;
        }
        this.props.onClose();
    }

    onInputChange = (event: ChangeEvent<HTMLInputElement>) => {
        this.setState({
            value: Math.max(Math.min(Number(event.target.value), 5024), 0)
        })
    }

    render() {
        // const buttonLabel = this.props.completeButtonLabel || 'Save';
        const showCancel = this.props.showCancel;
        return (
            <ReactModal
                /*
                  Boolean describing if the modal should be shown or not.
                */
                isOpen={this.props.show}
                ariaHideApp={false}
                onRequestClose={this.props.onClose}
                style={{
                    overlay: {
                        zIndex: 1000,
                        pointerEvents: 'all'
                    },
                    content: {
                        maxWidth: '500px',
                        maxHeight: '350px',
                        margin: 'auto',
                        pointerEvents: 'all'
                    }
                }}
            >
                <div>
                    <div style={{marginBottom: '10px', fontSize: '20px'}}>{this.props.title}</div>
                    {this.props.content}
                    <div className="buttonRow">
                        {showCancel && <div onClick={this.props.cancel}>
                            <button className="styledButton" style={{backgroundColor: '#808080'}}>Cancel</button>
                        </div>}
                        <div onClick={this.handleClose}>
                            <button className={this.props.invalid ? 'button-disabled styledButton' : 'styledButton'}
                                style={{backgroundColor: this.props.invalid ? '#afafaf' : '#f15a5a'}}>OK</button>
                        </div>
                    </div>

                </div>
            </ReactModal>
        );
    }
}
